jQuery.noConflict();
(($) => {
    function initialize() {
        $('.js-map').each(function () {
            let mapElement = $(this);
            let image = mapElement.data('marker');
            let latitude = mapElement.data('lat');
            let longitude = mapElement.data('lng');
            let zoom = mapElement.data('zoom') ? parseFloat(mapElement.data('zoom')) : 15;
            let style = window.mintDesignGoogleMapsStyle ? window.mintDesignGoogleMapsStyle : false;

            let myLatLng = {
                lat: parseFloat(latitude),
                lng: parseFloat(longitude)
            };
            let map = new google.maps.Map(this, {
                zoom: zoom,
                center: myLatLng,
                styles: style
            });

            if (image) {
                let marker = new google.maps.Marker({
                    position: myLatLng,
                    map: map,
                    icon: image
                });
            }
        });
    }

    $(window).on('load', function(){
        initialize();
    });
})(jQuery);
